export default function removeTrailingSlash (url: string = ''): string {
    return url.replace(/(.*)\/$/, '$1')
}
